import { render, staticRenderFns } from "./basic_search.vue?vue&type=template&id=2869aafe"
import script from "./basic_search.vue?vue&type=script&lang=js"
export * from "./basic_search.vue?vue&type=script&lang=js"
import style0 from "./basic_search.vue?vue&type=style&index=0&id=2869aafe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports